// ЗАКАЗ ВЛАДЕЛЬЦА 02.09.2026 (истина, план docs/TRIGGER-WIZARD-PLAN.md): «Подарок за
// подписку» запускается ЛЮБОЙ КОМБИНАЦИЕЙ входов Инстаграма, В ТОМ ЧИСЛЕ комментарием
// под публикацией — хоть один, хоть все шесть; у каждого входа свои настройки или их
// нет. Один бот, один сценарий, без скрытых копий.
//
// Тот же мастер, что «Кодовое слово в комментарии», с одной разницей: ЧТО ЗАПУСКАЕТ.
// Входы человек отмечает галочками (`entryEvents`), жёсткого набора у этой анкеты нет.
//
// Всё тело мастера — общее (ig-wizard.ts). Сборка — патчи канона шаблона
// scriptera:ig-gift-subscribe (копия канона кодового слова, миграция 20260901120000).
import { makeIgWizard, type IgWizardCfg } from './ig-wizard';
import type { TemplateWizardDef, WizardLocale } from './core';

/** Настройка анкеты — ею же ответы читает страница бота клиента (Scriptera A, lib/adm/bot-view.ts readIgAnswers). */
export const GIFT_IG_CFG: IgWizardCfg = {
  id: 'gift-ig',
  templateSource: 'scriptera:ig-gift-subscribe',
  // Чат на первом экране — сцена «Подарок за подписку» с примеров работ (ТЗ-3 Т1).
  // ВРЕМЕННО ДЛЯ СЪЁМКИ РОЛИКА (владелец 22.09.2026): после съёмки вернуть 's1'.
  demoScene: 's1',

  lead(locale: WizardLocale) {
    const ru = locale === 'ru';
    return {
      title: ru ? 'Подарок за подписку' : 'Gift for a follow',
      text: ru
        ? 'Пользователь пишет вам в директ, комментирует публикацию или эфир, отвечает на историю, ставит на неё реакцию или отмечает вас — бот здоровается в личных сообщениях, при желании проверяет подписку на аккаунт и отдаёт обещанное: ссылку, файл, промокод.'
        : 'A user writes to your direct, comments under a post or a live, replies to your story, reacts to it or mentions you — the bot greets them in DMs, optionally checks the account subscription and hands over what you promised: a link, a file, a promo code.',
    };
  },
};

export const giftIg: TemplateWizardDef = makeIgWizard(GIFT_IG_CFG);
